import { render, staticRenderFns } from "./ticketDetailAssign.vue?vue&type=template&id=5c8a39bf&scoped=true&"
import script from "./ticketDetailAssign.vue?vue&type=script&lang=js&"
export * from "./ticketDetailAssign.vue?vue&type=script&lang=js&"
import style0 from "./ticketDetailAssign.vue?vue&type=style&index=0&id=5c8a39bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a39bf",
  null
  
)

export default component.exports